import { Component } from "react";
import Footer from "../Footer/Footer";
import logo from "../../../assets/img/LogoCIC.png";

class LayoutPublico extends Component {
  componentDidMount() {
    document.body.classList.add("bg-gradient-primary");
    document.getElementById("footer").classList.add("fixed-bottom");
  }

  render() {
    return (
      <>
        <div className="container">
          {/* <!-- Outer Row --> */}
          <div className="row justify-content-center">
            <div className="col-9">
              <div className="card o-hidden border-0 shadow-lg my-5">
                <div className="card-body p-0">
                  {/* <!-- Nested Row within Card Body --> */}
                  <div className="sidebar-brand d-flex align-items-center justify-content-center bg-white mt-4">
                    <img
                      className="sidebar-brand-logo"
                      src={logo}
                      aria-label="Centro de Información Crediticia"
                    />
                  </div>
                  <div className="p-4">
                    <div className="container text-center">
                      {/* <!-- Begin Page Content --> */}
                      <div className="container-fluid">
                        {this.props.children}
                      </div>
                      {/* <!-- /.container-fluid --> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Footer --> */}
        <Footer />
        {/* <!-- End of Footer --> */}

        {/* <!-- Scroll to Top Button--> */}
        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
        </a>
      </>
    );
  }
}

export default LayoutPublico;
